export default __webpack_public_path__ + "static/media/sandwich-640w.9d48cf42.jpg";